import { DrilldownTable, 
// DrilldownTableRowCell,
// TrafficLightGroupLogic,
defaultTrafficLights, } from "../../../../../shared/interfaces-classes/index";
import { reportUtils } from '../../../../report-utils';
var 
// getBoolFromBoolishVar,
// processSingleVarHtml,
// processTemplateVarHtmlList,
// createDrilldownTableGroup,
// getCheckOrXOrNoDataFromBoolishVar,
getGenericGroupMsg = reportUtils.getGenericGroupMsg;
var genericGroupMsg = getGenericGroupMsg();
export var ictpItocLo1 = {
    'http://ictp-itoc-lo1': {
        columns: [
            {
                parent: 'LO1Voice',
                variablename: 'VoiceDash',
                desc: 'Identified necessary voice that is missing from current team',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'TextVoice'
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var TextVoice = varDict.TextVoice;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'Whose voice is missing?',
                                ],
                            },
                            {
                                header: 'Answer',
                                rows: [
                                    TextVoice,
                                ],
                            },
                            {
                                header: 'Correct Answer',
                                rows: [
                                    'Jean, a mother of two, who lives in Grand County and occasionally attends System of Care meetings for the health department to advise them on community needs',
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
            {
                parent: 'LO1Engage',
                variablename: 'EngageDash',
                desc: 'Identified the best way to engage missing voices',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        response: [
                            'TextEngage'
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var TextEngage = varDict.TextEngage;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'What is the best way to engage the missing voices?'
                                ],
                            },
                            {
                                header: 'Answer',
                                rows: [
                                    TextEngage,
                                ],
                            },
                            {
                                header: 'Correct Answer',
                                rows: [
                                    'Team members must build authentic relationships based in trust, acknowledging historical inequities and power structures, being willing to remain open-minded, and sharing leadership in adaptive ways. Stipends, childcare, and transportation may be provided upon request.',
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
            {
                parent: 'LO1New',
                variablename: 'NewDash',
                desc: 'Correctly ordered the team’s next steps to ensure participation and engagement',
                trafficLight: '',
                trafficLightGroupLogic: defaultTrafficLights,
                drilldown: {
                    vars: {
                        success: [
                            'LO1New',
                        ],
                    },
                    template: function (varDict) {
                        if (varDict.type === 'group') {
                            return genericGroupMsg;
                        }
                        var LO1New = varDict.LO1New;
                        var columns = [
                            {
                                header: 'Question',
                                rows: [
                                    'What steps should the team take to ensure the participation and engagement of all needed co-creation partners?',
                                ],
                            },
                            {
                                header: 'Correct?',
                                type: 'checkmark',
                                rows: [
                                    LO1New,
                                ],
                            },
                            {
                                header: 'Correct Answer',
                                rows: [
                                    "\n<p>1. Co-creation partners meet and discuss past efforts to address this problem and where they see areas for improvement. Team members share their own values and work together to create shared values that will guide the work.</p>\n\n<p>2. The roles of co-creation partners are negotiated and self-organized by the various group members, acknowledging that they may need to remain fluid throughout the process.</p>\n\n<p>The group creates self-monitoring checks and feedback loops that they will use throughout the implementation process.</p> \n                  \n                  "
                                ],
                            }
                        ];
                        var drilldownTableOpts = {
                            varDict: varDict,
                            columns: columns,
                            title: '',
                            subtitle: '',
                        };
                        var html = new DrilldownTable(drilldownTableOpts).html;
                        return html;
                    }
                },
            },
        ]
    }
};
